import { mapGetters } from 'vuex'
import CciArticleListSection from './CciArticleListSection.vue'

export default {
  data () {
    return {
      currentScrollValue: 0.0
    }
  },
  created () {
    // window.addEventListener('message', this.messageHandler, false)
    // document.addEventListener('keydown', this.checkKey)
  },
  mounted () {
    var listContainer = document.getElementById('article-list-container')
    listContainer.addEventListener('scroll', this.didScroll)
  },
  computed: {
    pageThumbnail: function () {
      if (this.currentArticle !== undefined) {
        return this.getEncodedResourceUrl(this.currentArticle.page.thumbnail, this.currentArticle.page.attributes.LastRev)
      }
    },
    validSections: function () {
      var validSecs = []
      for (var i = 0; i < this.sections.length; i++) {
        if (this.sections[i].articles.length > 0) {
          var filteredArticles = this.filterArticles(this.sections[i].articles)
          if (filteredArticles.length > 0) {
            validSecs.push(this.sections[i])
          }
        }
      }
      return validSecs
    },
    ...mapGetters({
      opsUrl: 'getOpsUrl',
      sections: 'getSections',
      currentArticle: 'getCurrentArticle',
      articles: 'getArticles'
    })
  },
  methods: {
    setCurrentPage () {
      var pageNr = this.currentArticle.page.pageNumber
      this.$router.push({ name: 'pages', params: { pageNr: pageNr }})
      this.$store.commit('setResetInterstitials', true)
    },
    filterArticles (articles) {
      return articles.filter(function (article) {
        return article.attributes.JumpOriginArticleId === undefined && article.attributes.TeaserText !== ''
      })
    },
    // messageHandler (event) {
    //   let str = event.data
    //   var command = str
    //   // console.log(str)
    //   if (typeof str === 'string' || str instanceof String) {
    //     if (str.indexOf('?') > -1) {
    //       let n = str.indexOf('?')
    //       // console.log(n)
    //       try {
    //         command = str.slice(0, n)
    //       } catch (err) {
    //         console.log('From CciArticleModal.js')
    //         console.log(err.msg)
    //       }
    //     }
    //   }
    //   console.log(command)
    //
    //   if (command === 'linkInArticleClicked.cci') {
    //     let n = str.indexOf('?')
    //     // console.log('linked in article , n : ' + n)
    //     try {
    //       let link = str.slice(n + 9, str.length)
    //       window.open(link, '_blank')
    //       // window.location.href = link
    //     } catch (err) {
    //       console.log('From CciArticleModal.js link in article clicked')
    //       console.log(err.msg)
    //     }
    //   }
    //
    //   if (command === 'keydownInArticle.cci') {
    //     let n = str.indexOf('?')
    //     // console.log('keydownInArticle, n : ' + n)
    //     try {
    //       let keycode = str.slice(n + '?keycode='.length, str.length)
    //       if (keycode === '27') {
    //         if (this.$store.state.showImageGalleryInArticle) {
    //           this.$store.commit('setShowImageGalleryInArticle', false)
    //         }
    //       }
    //     } catch (err) {
    //       console.log('From CciArticleModal.js keydownInArticle')
    //       console.log(err.msg)
    //     }
    //   }
    //
    //   if (command === 'imageGalleryClicked.cci') {
    //     this.$store.commit('setShowImageGalleryInArticle', true)
    //   }
    // },
    didScroll (event) {
      let target = event.target
      let heightDiff = target.scrollHeight - target.offsetHeight
      let percent = target.scrollTop / heightDiff
      let percentRounded = Math.floor(percent * 100) / 100
      if (this.currentScrollValue !== percentRounded) {
        this.$cciEventTrackingPlugin.trackEvent('ContextArticleList', 'ActionArticleListScrollView', undefined, undefined, percentRounded)
      }
      this.currentScrollValue = percentRounded
    },
    // checkKey(e) {
    //   if (!this.showIssueOverview) {
    //     e = e || window.event
    //     if (e.keyCode == '38' || e.keyCode == '40') {
    //       let filteredArticles = this.filterArticles(this.articles)
    //       var selectIndex = filteredArticles.indexOf(this.currentArticle)
    //       if (e.keyCode == '38') {
    //         // up
    //         selectIndex--
    //       } else if (e.keyCode == '40') {
    //         // down
    //         selectIndex++
    //       }
    //       if (selectIndex >= 0 && selectIndex < filteredArticles.length) {
    //         let artElem = document.getElementById('article-list-' + selectIndex)
    //         if (selectIndex > 0) {
    //           let scrollToIndex = selectIndex - 1
    //           let scrollToElem = document.getElementById('article-list-' + scrollToIndex)
    //           scrollToElem.scrollIntoView()
    //         }
    //
    //         var articleElements = document.getElementsByClassName('article-list-item')
    //         for (var i = 0; i < articleElements.length; i++) {
    //           articleElements[i].classList.remove('active')
    //         }
    //         artElem.classList.add('active')
    //         this.$cciEventTrackingPlugin.trackEvent('ContextArticleList', 'ActionArticleListCellClick', filteredArticles[selectIndex])
    //         this.$store.commit('setCurrentArticle', filteredArticles[selectIndex])
    //       }
    //     }
    //   }
    // },
    isInViewport (elem) {
      var bounding = elem.getBoundingClientRect()
      return (
        bounding.top >= 0 &&
        bounding.left >= 0 &&
        bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
        bounding.right <= (window.innerWidth || document.documentElement.clientWidth)
      )
    }
  },
  beforeDestroy () {
    // window.removeEventListener('message', this.messageHandler)
    // document.removeEventListener('keydown', this.checkKey)
  },
  components: {
    CciArticleListSection
  }
}
